
import { updateAppConfig } from '#app/config'
import { defuFn } from 'defu'

const inlineConfig = {
  "nuxt": {
    "buildId": "c36bec80-4245-43ac-90e6-9c2ec05d7867"
  }
}

// Vite - webpack is handled directly in #app/config
if (import.meta.hot) {
  import.meta.hot.accept((newModule) => {
    updateAppConfig(newModule.default)
  })
}

import cfg0 from "/Volumes/Tian_SanDisk/DEV/datawang/frontend/app.config.ts"

export default /*@__PURE__*/ defuFn(cfg0, inlineConfig)
